import { ImageOutlined as ImageIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { getCachedKeyedImageAsDataUrl } from '@/lib/utils/readKeyedImageAsDataUrl';
import { useContext } from 'react';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import shouldShowInappropriateContentIndicators from '@/lib/files/shouldShowInappropriateContentIndicators';
import LoadingStateWrapper from './LoadingStateWrapper';
import TinyThumbnailAsLoadingPlaceholder from './TinyThumbnailAsLoadingPlaceholder';

const ThumbnailBannerLoadingState = () => {
  const { portfolioItem } = useContext(PortfolioItemContext);

  const cachedTinyThumbnailAsDataUrl =
    portfolioItem.thumbnail!.file.thumbnailStorageFilename !== null
      ? getCachedKeyedImageAsDataUrl(
          portfolioItem.thumbnail!.file.thumbnailStorageFilename,
        )
      : null;

  const showInappropriateContentIndicators =
    shouldShowInappropriateContentIndicators(portfolioItem.thumbnail!);

  if (cachedTinyThumbnailAsDataUrl && !showInappropriateContentIndicators) {
    return (
      <TinyThumbnailAsLoadingPlaceholder src={cachedTinyThumbnailAsDataUrl}>
        <CircularProgress size={18} />
      </TinyThumbnailAsLoadingPlaceholder>
    );
  }

  return (
    <LoadingStateWrapper>
      <ImageIcon />
      <div>
        <CircularProgress size={18} />
      </div>
    </LoadingStateWrapper>
  );
};

export default ThumbnailBannerLoadingState;
